import SelectorSearchboxPresentation from 'components/SelectorSearchbox/SelectorSearchboxPresentation'

export default {
  Presentation: SelectorSearchboxPresentation,
}
